var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoadHighlight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 120 145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 10,10 h 100 v 100 h -25 l -25,25 l -25,-25 h -25 Z",
    id: "background",
    style: {
      fill: "#0f0",
      stroke: "#0f0",
      strokeWidth: 20
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10,10 h 100 v 100 h -25 l -25,25 l -25,-25 h -25 Z",
    id: "foreground",
    style: {
      fill: "#fff",
      stroke: "#45a",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("svg", _extends({
    x: 25,
    y: 25,
    width: 70,
    height: 70,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8421 5.4C19.8411 5.4 19.8389 5.39895 19.8379 5.39895L18.9263 0.846316C18.8284 0.353684 18.3968 0 17.8947 0H4.21053C3.70842 0 3.27684 0.353684 3.17895 0.846316L2.26737 5.39895C2.26632 5.39895 2.26421 5.4 2.26316 5.4C0.957895 5.77895 0 7 0 8.42105V18.9474C0 19.5284 0.471579 20 1.05263 20H4.21053V16.8421H17.8947V20H21.0526C21.6337 20 22.1053 19.5284 22.1053 18.9474V8.42105C22.1053 7 21.1474 5.77895 19.8421 5.4ZM8.42105 9.47368H13.6842V11.5789H8.42105V9.47368ZM16.8421 9.47368H20V11.5789H16.8421V9.47368ZM2.10526 9.47368H5.26316V11.5789H2.10526V9.47368ZM17.0316 2.10526L17.6632 5.26316H4.44211L5.07368 2.10526H17.0316Z",
    fill: "black"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadHighlight);
export default __webpack_public_path__ + "static/media/RoadHighlight.2500080e955c5146176357318800b0f5.svg";
export { ForwardRef as ReactComponent };